import { useEffect, useCallback, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const GoogleSignIn = ({ onStartAuth }) => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const googleInitialized = useRef(false);

  const handleCredentialResponse = useCallback(async (response) => {
    try {
      // Set loading state when auth starts
      onStartAuth?.();
      
      console.log('Google response:', response);
      
      const backendResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/google`,
        { token: response.credential },
        {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true
        }
      );

      console.log('Backend response:', backendResponse.data);
      
      await login(backendResponse.data);
      navigate('/dashboard');
    } catch (error) {
      console.error('Google Sign-In error:', error);
      if (error.response) {
        console.error('Error response:', error.response.data);
      }
    }
  }, [login, navigate, onStartAuth]);

  useEffect(() => {
    if (googleInitialized.current) return;

    const initializeGoogleSignIn = () => {
      if (window.google && window.google.accounts) {
        window.google.accounts.id.initialize({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          callback: handleCredentialResponse,
          ux_mode: 'popup',
          auto_select: false,
          context: 'signin'
        });

        const buttonContainer = document.getElementById("googleSignInDiv");
        if (buttonContainer && !buttonContainer.hasChildNodes()) {
          window.google.accounts.id.renderButton(
            buttonContainer,
            { 
              theme: "outline", 
              size: "large", 
              width: 280,
              text: 'continue_with',
              shape: 'rectangular'
            }
          );
        }
        googleInitialized.current = true;
      } else {
        setTimeout(initializeGoogleSignIn, 100);
      }
    };

    initializeGoogleSignIn();

    return () => {
      if (window.google && window.google.accounts) {
        window.google.accounts.id.cancel();
        googleInitialized.current = false;
      }
    };
  }, [handleCredentialResponse]);

  return (
    <div 
      id="googleSignInDiv" 
      style={{ 
        display: 'flex',
        justifyContent: 'center',
        marginTop: '10px',
        minHeight: '40px'
      }}
    />
  );
};

export default GoogleSignIn;

// Add this function to check if the user is connected with Google
export const isGoogleConnected = (user) => {
  // Check multiple possible fields where Google connection might be stored
  return !!(
    user?.google_id || 
    user?.googleId || 
    user?.provider === 'google' ||
    user?.image?.includes('googleusercontent.com') // This is a good indicator
  );
}; 